<template>
  <div class="s-visitor-end-container">
    <div class="s-question-list-wrap" v-if="questionsDataList.length > 0">
      <div class="text-title">问题列表</div>
      <div class="s-question-list" v-for="(item, index) in questionsDataList" :key="index">
        <div class="answer-questions-desc">
          <div class="questions-img">
            <el-image v-if="item.imgType == 'image'" :src="item.qimg" :preview-src-list="[item.qimg]" class="img">
            </el-image>
            <!-- <img :src="item.qimg" class="img" alt v-if="item.imgType == 'image'"/> -->
            <video v-if="item.imgType == 'video'" :src="item.qimg" class="img" controls></video>
          </div>
          <div>
            <div class="questions-title">{{ item.qtitle }}</div>
            <div class="questions-type">
              <div>
                <span class="span-title">问题类型：</span>{{ item.qtypeValue }}
              </div>
              <div>
                <span class="span-title">提问人：</span>{{ item.createUserName }}
              </div>
              <div>
                <span class="span-title">时间：</span>{{ item.createTime }}
              </div>
            </div>
            <div class="questions-desc">
              <div class="questions-desc-title">问题描述：</div>
              {{ item.qinfo }}
            </div>
          </div>
        </div>
        <div class="questions-notAnswer-flag" v-show="item.questionState == 0">
          未回答
        </div>
        <div class="questions-answer-flag" v-show="item.questionState == 1">
          已回答
        </div>
        <div class="questions-answer-btn" @click="goDialog(item)">追问</div>
        <div class="experts-reply-wrap" ref="replyWrap" v-if="item.fsQaInfoList != null">
          <div class="experts-reply" v-for="(item1, a) in item.fsQaInfoList" :key="a">
            <!-- <div class="experts-reply-title">{{ item1.isExperts == 1 ? item1.createUserName + "专家:" : item1.createUserName + ":" }}
            </div> -->
            <div class="experts-reply-title">
              {{ item1.isExperts == 1 ? "专家回复:" : "追问:" }}
            </div>
            <div class="answerTime">{{ item1.createTime || "--" }}</div>
            <span>{{ item1.createUserName || "--" }}</span>：<span>{{ item1.content || "--" }}</span>
          </div>
        </div>
        <div class="experts-reply experts-reply-noData" style="
            height: 170px;
            text-align: center;
            line-height: 170px;
            color: #666;
            font-size: 16px;
          " v-if="item.fsQaInfoList == null">
          暂无数据!
        </div>
      </div>
    </div>
    <div v-else>
        <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>
    <div class="s-transaction-pagination" v-if="questionsDataList.length > 0">
      <el-pagination class="tab_pagination" background :page-size="pageSize" :current-page="currentPage"
        layout="prev, pager, next" @current-change="currentChange" :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="dialog" :before-close="closeDialog" :close-on-click-modal="false" width="1100px">
      <div class="question-container-container">
        <el-image v-if="questionObj.imgType == 'image'" :src="questionObj.qimg" :preview-src-list="[questionObj.qimg]"
          class="question-user-image"></el-image>
        <video v-if="questionObj.imgType == 'video'" :src="questionObj.qimg" class="question-user-image"
          controls></video>
        <!-- <img :src="questionObj.qimg" class="question-user-image" alt /> -->
        <div class="question-user-content">
          <div class="question-content-title">{{ questionObj.qtitle }}</div>
          <div class="question-content-form">
            <span class="label">问题类型：</span>
            <span class="value mr70">{{ questionObj.qtypeValue }}</span>
            <span class="label">提问人：</span>
            <span class="value mr110">{{ questionObj.createUserName }}</span>
            <span class="label">时间：</span>
            <span class="value">{{ questionObj.createTime }}</span>
          </div>
          <div class="question-content-desc">问题描述：</div>
          <div class="question-content-text">
            <p>{{ questionObj.qinfo }}</p>
          </div>
        </div>
      </div>
      <div class="experts-reply-title">专家回复</div>
      <div class="experts-reply-wrap" ref="replyWrap" v-if="questionArr != null">
        <div class="experts-reply" v-for="(itemChild, idnn) in questionArr" :key="idnn">
          <div class="answerTime">{{ itemChild.createTime || "--" }}</div>
          <span>{{ itemChild.createUserName || "--" }}</span>：<span>{{ itemChild.content || "--" }}</span>
        </div>
      </div>
      <div class="experts-reply experts-reply-noData" style="
          height: 170px;
          text-align: center;
          line-height: 170px;
          color: #666;
          font-size: 16px;
        " v-if="questionArr == null">
        暂无数据!
      </div>
      <div class="addAsk">
        <input maxlength="60" v-model="askVal" :placeholder="'请输入追问内容'" type="text"
          @keyup.enter="expertAnsweringQuestion" />
        <span class="ask-more-button" @click="expertAnsweringQuestion">
          追问
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getQuestionsListPage,
  expertAnsweringQuestion,
  getQaInfoList,
} from "../utils/api/personalCenter";
export default {
  name: "visitor-end",
  data() {
    return {
      formInline: {
        user: "",
        region: "",
        date: [],
      },
      questionsDataList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialog: false,
      clickId: "",
      askVal: "",
      questionArr: [],
      questionObj: {},
      defaultImg: require("../assets/image/dealmakers/default.png"),
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    this.getQuestionsListPage();
  },
  methods: {
    //问题列表
    async getQuestionsListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await getQuestionsListPage(params);
      if (res.data.code == 0) {
        this.questionsDataList = res.data.data.records;
        this.questionsDataList.forEach((item) => {
          if (item.qimg == "") {
            item.qimg = this.defaultImg;
          } else {
            if (item.qimg.includes("http")) {
              item.qimg = item.qimg.split(",")[0];
              if (
                item.qimg.split(".")[item.qimg.split(".").length - 1] == "mp4"
              ) {
                item.imgType = "video";
              } else {
                item.imgType = "image";
              }
            } else {
              item.qimg = this.imgURL + "/" + item.qimg.split(",")[0];
              if (
                item.qimg.split(".")[item.qimg.split(".").length - 1] == "mp4"
              ) {
                item.imgType = "video";
              } else {
                item.imgType = "image";
              }
            }
            console.log("this.qimg", this.qimg);
          }
        });
        this.total = res.data.data.total;
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    goDialog(obj) {
      this.dialog = true;
      this.clickId = obj.id;
      this.questionsDataList.forEach((item) => {
        if (this.clickId == item.id) {
          this.questionObj = item;
          if (this.questionObj.qimg == "") {
            this.questionObj.qimg = this.defaultImg;
          } else {
            if (this.questionObj.qimg.includes("http")) {
              this.questionObj.qimg = this.questionObj.qimg.split(",")[0];
              if (
                this.questionObj.qimg.split(".")[
                this.questionObj.qimg.split(".").length - 1
                ] == "mp4"
              ) {
                this.questionObj.imgType = "video";
              } else {
                this.questionObj.imgType = "image";
              }
            } else {
              this.questionObj.qimg =
                this.questionObj.qimg +
                "/" +
                this.questionObj.qimg.split(",")[0];
              if (
                this.questionObj.qimg.split(".")[
                this.questionObj.qimg.split(".").length - 1
                ] == "mp4"
              ) {
                this.questionObj.imgType = "video";
              } else {
                this.questionObj.imgType = "image";
              }
            }
          }
        }
      });
      this.getQaInfoList();
    },
    // 详情
    async getQaInfoList() {
      let params = {
        qaId: this.clickId,
      };
      let res = await getQaInfoList(params);
      if (res.data.code == 0) {
        this.questionArr = res.data.data;
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    //追问
    async expertAnsweringQuestion() {
      let data = {
        qaId: this.clickId,
        content: this.askVal,
        createUserId: localStorage.getItem("userInfo").userId,
        createUserName: localStorage.getItem("userInfo").userAccount,
      };
      let res = await expertAnsweringQuestion(data);
      if (res.data.code == 0) {
        this.$message.success(res.data.data);
        this.askVal = "";
        this.getQaInfoList();
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    closeDialog() {
      this.dialog = false;
      this.getQuestionsListPage();
    },
    currentChange(value) {
      this.currentPage = value;
      this.getQuestionsListPage();
    },
    //更改pageSize
    pageSizeChange(value) {
      this.pageSize = value;
      this.getQuestionsListPage();
    },
    // //回复
    // expertAnsweringQuestion() {
    //   expertAnsweringQuestion({
    //     qaId: this.questionInfo.id,
    //     content: this.askVal,
    //     createUserId: localStorage.getItem("userInfo").userId,
    //     createUserName: localStorage.getItem("userInfo").userAccount,
    //   })
    //     .then((res) => {
    //       this.askVal = "";
    //       this.getQaInfoList(this.questionInfo.id);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/personalCenter.scss";
</style>
<style lang="scss"></style>
